import { ElementRef, Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, delay, of } from 'rxjs';

import { ActivityDateData, ImageResultData } from '@hiptraveler/data-access/api';
import { ItineraryState } from '@hiptraveler/data-access/itinerary';
import { skeletonVisibilityDelay } from '../../common';

@Injectable()
export class HighlightCarouselService {

  @Select(ItineraryState.actDate) actDate$: Observable<ActivityDateData[] | null>;
  @Select(ItineraryState.imageInformation) imageInformation$: Observable<ImageResultData>;

  skeletonVisibility$ = of(true).pipe(
    delay(skeletonVisibilityDelay)
  );

  scrollHighlightSlider(element: ElementRef<HTMLElement>, currentIndex: number, length: number, option: string): void {
    
    const SLIDER_ITEM_WIDTH = 104;
    const slider = element.nativeElement.querySelectorAll('.highlight--slider').item(0);
    const sliderScrollPosition = slider.scrollLeft + (option === 'next' ? 1 : -1) * SLIDER_ITEM_WIDTH;

    if (currentIndex === 0) {
      slider.scrollTo({
        left: 0, behavior: 'smooth'
      });
    } else if (currentIndex === length-1) {
      slider.scrollTo({
        left: SLIDER_ITEM_WIDTH * (length - 1), behavior: 'smooth'
      });
    } else {
      slider.scrollTo({
        left: sliderScrollPosition, behavior: 'smooth'
      });
    }
  }

}
